// プレビュー音声のグローバル音量。
//
// BGM・効果音（HTMLAudio）と、ジングル・大砲音・スティング音（WebAudio 合成）は
// 生成箇所が分かれているため、単一のマスター音量(0..1)を共有して全経路へ反映する。
// HTMLAudio 側は要素の .volume に「素材音量 × マスター音量」を掛け、WebAudio 側は
// 再生時に getAudioVolume() を参照してゲインへ掛ける（合成音は音量 0 のとき発音を
// スキップする）。PreviewPanel の音量スライダーが setAudioVolume で切り替える。

let volume = 1

/** 現在のマスター音量(0..1)。WebAudio のゲイン算出・発音判定に使う。 */
export const getAudioVolume = (): number => volume

/** マスター音量を設定する(0..1 にクランプ)。PreviewPanel の音量操作から呼ぶ。 */
export const setAudioVolume = (value: number): void => {
  volume = Math.min(1, Math.max(0, value))
}

/** 実質ミュート（音量 0）か。WebAudio 合成音の発音前チェックに使う。 */
export const isAudioMuted = (): boolean => volume <= 0
